import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Alert from 'flarum/common/components/Alert';
import UploadButton from './UploadButton';
import UserFileList from '../../common/components/UserFileList';
import DragAndDrop from './DragAndDrop';
import ItemList from 'flarum/common/utils/ItemList';
import SharedFileList from '../../common/components/SharedFileList';
import FileListState from '../../common/states/FileListState';
import { insertWithDisplayName } from '../utils/applyDisplayName';
export default class FileManagerModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "uploader", void 0);
    _defineProperty(this, "selectedFiles", []);
    _defineProperty(this, "multiSelect", true);
    _defineProperty(this, "restrictFileType", null);
    _defineProperty(this, "dragDrop", null);
    _defineProperty(this, "selectedFilesLibrary", 'user');
    _defineProperty(this, "userFileState", void 0);
    _defineProperty(this, "sharedFileState", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.uploader = vnode.attrs.uploader;
    this.selectedFiles = [];
    this.multiSelect = vnode.attrs.multiSelect === undefined ? true : vnode.attrs.multiSelect;
    this.restrictFileType = vnode.attrs.restrictFileType || null;
    this.dragDrop = null;
    this.selectedFilesLibrary = vnode.attrs.defaultFilesLibrary || 'user';
    this.userFileState = new FileListState();
    this.sharedFileState = new FileListState(true);
    this.uploader.setState(this.userFileState);
    this.onUpload();
  }
  className() {
    return 'Modal--large fof-file-manager-modal';
  }
  title() {
    return '';
  }
  content() {
    return null;
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.dragDrop = new DragAndDrop(files => this.uploader.upload(files, false), this.$().find('.Modal-content')[0]);
  }
  onremove() {
    if (this.dragDrop) {
      this.dragDrop.unload();
    }
  }
  view() {
    const fileCount = this.selectedFiles.length;
    const {
      hideUser,
      hideShared
    } = this.attrs;
    return m("div", {
      className: `Modal modal-dialog ${this.className()}`
    }, m("div", {
      className: "Modal-content"
    }, m("div", {
      className: "fof-modal-buttons App-backControl"
    }, !hideUser && this.selectedFilesLibrary === 'user' && m(UploadButton, {
      uploader: this.uploader,
      disabled: this.userFileState.isLoading(),
      isMediaUploadButton: true
    }), app.session.user && app.session.user.uploadSharedFiles() && !hideShared && this.selectedFilesLibrary === 'shared' && m(Button, {
      className: "Button",
      icon: "fas fa-file-upload",
      onclick: () => {
        this.showUploadModal();
      }
    }, app.translator.trans('fof-upload.forum.buttons.upload'))), m("div", {
      className: "fof-drag-and-drop"
    }, m("div", {
      className: "fof-drag-and-drop-release"
    }, m("i", {
      className: "fas fa-cloud-upload-alt"
    }), app.translator.trans('fof-upload.lib.file_list.release_to_upload'))), m("div", {
      className: "Modal-header"
    }, m("h3", {
      className: "App-titleControl App-titleControl--text"
    }, app.translator.trans('fof-upload.forum.media_manager')), app.session.user && app.session.user.accessSharedFiles() && !hideUser && !hideShared && m("div", {
      className: "LibrarySelection"
    }, this.fileLibraryButtonItems().toArray())), this.alertAttrs && m("div", {
      className: "Modal-alert"
    }, m(Alert, this.alertAttrs)), m("div", {
      className: "Modal-body"
    }, this.selectedFilesLibrary === 'user' && this.userFilesContent(), this.selectedFilesLibrary === 'shared' && this.sharedFilesContent()), m("div", {
      className: "Modal-footer"
    }, m(Button, {
      onclick: this.hide.bind(this),
      className: "Button"
    }, app.translator.trans('fof-upload.forum.buttons.cancel')), m(Button, {
      onclick: this.onSelect.bind(this),
      disabled: this.selectedFiles.length === 0 || !this.multiSelect && this.selectedFiles.length > 1,
      className: "Button Button--primary"
    }, app.translator.trans('fof-upload.lib.file_list.confirm_selection_btn', {
      fileCount
    })))));
  }
  fileLibraryButtonItems() {
    const items = new ItemList();
    items.add('user', m(Button, {
      className: `Button Button--flat ${this.selectedFilesLibrary === 'user' ? 'active' : ''}`,
      onclick: () => this.setLibrary('user')
    }, app.translator.trans('fof-upload.forum.buttons.media')));
    items.add('shared', m(Button, {
      className: `Button Button--flat ${this.selectedFilesLibrary === 'shared' ? 'active' : ''}`,
      onclick: () => this.setLibrary('shared')
    }, app.translator.trans('fof-upload.forum.buttons.shared_media')));
    return items;
  }
  setLibrary(library) {
    this.selectedFilesLibrary = library;
    m.redraw();
  }
  userFilesContent() {
    return m(UserFileList, {
      user: this.attrs.user,
      selectable: true,
      onFileSelect: this.onFileSelect.bind(this),
      selectedFiles: this.selectedFiles,
      restrictFileType: this.restrictFileType,
      fileState: this.userFileState,
      onDelete: this.onDelete.bind(this)
    });
  }
  sharedFilesContent() {
    return m(SharedFileList, {
      selectable: true,
      onFileSelect: this.onFileSelect.bind(this),
      selectedFiles: this.selectedFiles,
      restrictFileType: this.restrictFileType,
      user: this.attrs.user,
      fileState: this.sharedFileState,
      onDelete: this.onDelete.bind(this)
    });
  }
  onFileSelect(file) {
    const fileId = file.id();
    if (!fileId) return;
    const itemPosition = this.selectedFiles.indexOf(fileId);
    if (itemPosition >= 0) {
      this.selectedFiles.splice(itemPosition, 1);
    } else {
      if (this.multiSelect) {
        this.selectedFiles.push(fileId);
      } else {
        this.selectedFiles = [fileId];
      }
    }
  }
  onUpload() {
    this.uploader.on('success', response => {
      const {
        file
      } = response;
      const fileId = file.id();
      if (fileId) {
        if (this.multiSelect) {
          this.selectedFiles.push(fileId);
        } else {
          this.selectedFiles = [fileId];
        }
      }
    });
  }
  onSelect() {
    this.hide();
    if (this.attrs.onSelect) {
      this.attrs.onSelect(this.selectedFiles);
      return;
    }
    const files = this.selectedFiles.map(fileId => app.store.getById('files', fileId) || app.store.getById('shared-files', fileId)).filter(file => !!file && typeof file.bbcode === 'function');
    if (!app.composer.editor) return;
    const insert = bbcode => app.composer.editor.insertAtCursor(bbcode + '\n', false);

    // Prompting per file would mean a chain of modals, so the display name is
    // only offered when a single file is being inserted. Multi-select keeps the
    // file names, which the author can still edit in the composer afterwards.
    if (files.length === 1) {
      insertWithDisplayName(files[0], insert);
      return;
    }
    files.forEach(file => insert(file.bbcode()));
  }
  showUploadModal() {
    app.modal.show(() => import(/* webpackChunkName: 'common/components/UploadSharedFileModal', webpackMode: 'lazy-once' */ '../../common/components/UploadSharedFileModal'), {
      onUploadComplete: files => {
        this.sharedFileState.addToList(files);
      }
    }, true);
  }
  onDelete(file) {
    this.sharedFileState.removeFromList(file);
    this.userFileState.removeFromList(file);
  }
}
flarum.reg.add('fof-upload', 'forum/components/FileManagerModal', FileManagerModal);flarum.reg.addChunkModule('687', '617', 'fof-upload', 'common/components/UploadSharedFileModal');